import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../../flex";

export const AustraliaPostCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  apiKey: input<string>({ validator: nonEmptyValidator }),
  apiSecret: input<string>({ validator: nonEmptyValidator }),
});

export type AustraliaPostCarrierValue = InputSchema.Value<
  typeof AustraliaPostCarrierInput
>;

export type AustraliaPostCarrierForm = InputSchema.Input<
  typeof AustraliaPostCarrierInput
>;

export const australiaPostCarrierDefault = (): AustraliaPostCarrierValue => ({
  accountNumber: "",
  apiKey: "",
  apiSecret: "",
});

export const CreateAustraliaPostCarrierForm = memo(
  function CreateAustraliaPostCarrierForm({
    carrierInput,
  }: {
    carrierInput: AustraliaPostCarrierForm;
  }) {
    return (
      <Flex dir="column">
        <RedoTextInput
          label="Account number"
          placeholder=""
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="API key"
          placeholder=""
          setValue={carrierInput.inputs.apiKey.setValue}
          value={carrierInput.inputs.apiKey.value}
        />
        <RedoTextInput
          label="API secret"
          placeholder=""
          setValue={carrierInput.inputs.apiSecret.setValue}
          value={carrierInput.inputs.apiSecret.value}
        />
      </Flex>
    );
  },
);
